export default "__VITE_ASSET__3e8d1f8c__"